module.exports = __webpack_public_path__ + "img/workforce.273e27b7.svg";